<template>
	<b-modal
		v-model="showModal"
		no-close-on-backdrop
		id="selectexistingmodal"
		centered
		hide-footer
		hide-header
		@show="filterDocList"
		@hidden="closemodal"
	>
		<div class="d-flex">
			<div class="candash-modal-left"></div>
			<div class="width-94">
				<div class="candash-modal-top p-3">
					<div class="width-97">
						<div class="candash-modal-head d-flex align-items-center">
							<!-- <img
								class="mr-3"
								src="@/assets/mobile/assprog/mobileBackArrow.svg"
								alt=""
							/> -->
							Select from existing
						</div>
					</div>
					<div
						@click="closemodal"
						class="d-flex justify-content-end align-items-start pointer"
					>
						<img
							class="rotate-on-hover"
							src="@/assets/newdesign/dashboard/blueCross.svg"
							alt=""
						/>
					</div>
				</div>
				<div class="jdp-modal-oveflow-3">
					<div class="w40 jdp-exist-left-overflow-2">
						<div
							v-for="(doc, ind) in documentList"
							:key="doc.categoryID"
							class="d-flex flex-column"
						>
							<div class="asp-small-grey-txt-2">{{ doc.categoryTitle }}</div>
							<div
								v-for="(subDoc, i) in doc.documents"
								:key="i"
								class="d-flex align-items-center pointer"
								:class="{
									'mt-2': subDoc.document != null,
									'mob-radio-group': !allowMultiple,
								}"
							>
								<template v-if="subDoc.document != null">
									<b-form-radio
										v-if="!allowMultiple"
										v-model="selectedDocIndex"
										:value="subDoc.document.documentID"
										@change="selectTheDocuments(subDoc)"
									/>
									<b-form-checkbox
										v-else
										class="dynamic-check"
										v-model="selectedDocIndexMultiple"
										:value="subDoc.document.documentID"
										@change="handleCheckboxChange(subDoc)"
									/>
									<div class="sel-exis-selected ml-2">
										<img
											class="m-2"
											src="@/assets/newdesign/jdprogress/rd-doc.svg"
											alt=""
										/>
										<div class="text-truncate w80">
											{{ subDoc.documentName }}
										</div>
									</div>
								</template>
							</div>
							<div
								v-for="subDoc in doc.otherDocuments"
								:key="subDoc.documentID"
								class="d-flex align-items-center mt-2"
								:class="{
									'mt-2': subDoc.document != null,
									'mob-radio-group': !allowMultiple,
								}"
							>
								<b-form-radio
									v-if="!allowMultiple"
									v-model="selectedDocIndex"
									:value="subDoc.documentID"
									@change="selectTheDocuments(subDoc)"
								/>
								<b-form-checkbox
									class="dynamic-check"
									v-else
									v-model="selectedDocIndexMultiple"
									:value="subDoc.documentID"
									@change="handleCheckboxChange(subDoc)"
								/>
								<div class="sel-exis-selected ml-2">
									<img
										class="m-2"
										src="@/assets/newdesign/jdprogress/rd-doc.svg"
										alt=""
									/>
									<div class="text-truncate w80">
										{{ subDoc.documentName }}
									</div>
								</div>
							</div>
							<hr class="hr-back mr-2" v-if="ind !== documentList.length - 1" />
						</div>
					</div>
					<div class="w60 d-flex justify-content-center">
						<div class="jdp-exist-right-overflow">
							<div v-if="selectedDocIndex != null || selectedDocs.length !== 0">
								<pdf
									ref="pdf"
									class="h-100 w-100"
									:src="selectedDocs[0].link"
									:page="currentPage"
									@num-pages="numPages = $event"
									@link-clicked="currentPage = $event"
									@page-loaded="currentPage = $event"
								/>
							</div>
							<div
								class="h-100 w-100 d-flex align-items-center justify-content-center"
								v-else
							>
								<img
									src="@/assets/newdesign/meesho/no-docs-selected.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
				<div
					class="candash-modal-footer d-flex align-items-center justify-content-end"
				>
					<b-button @click="closemodal" class="candash-cancelBtn mr-4 pointer"
						>Cancel</b-button
					>
					<b-button @click="selectDocuments" class="candash-addBtn pointer"
						>Select</b-button
					>
				</div>
			</div>
		</div>
	</b-modal>
</template>
<script>
import pdf from "vue-pdf";

export default {
	name: "SelectExistingModal",
	props: {
		showModal: Boolean,
		allowMultiple: Boolean,
		docList: Array,
	},
	components: {
		pdf,
	},
	data() {
		return {
			// ARRAYS
			selectedDocs: [],
			selectedDocIndexMultiple: [],
			documentList: [],

			// NUMBERS
			selectedDocIndex: null,
			numPages: 0,
			currentPage: 1,
		};
	},
	methods: {
		filterDocList() {
			this.documentList = this.docList.filter((category) => {
				const hasValidDocument = category.documents.some(
					(doc) => doc.document !== null
				);
				const hasOtherDocuments =
					category.otherDocuments && category.otherDocuments.length > 0;
				return hasValidDocument || hasOtherDocuments;
			});
		},
		selectTheDocuments(subDoc) {
			this.selectedDocs = [];
			if (subDoc.hasOwnProperty("document")) {
				this.selectedDocs.push({
					link: subDoc.document.documentSource[0],
					path: subDoc.document.path[0],
				});
			} else {
				this.selectedDocs.push({
					link: subDoc.documentSource[0],
					path: subDoc.path[0],
				});
			}
		},
		handleCheckboxChange(subDoc) {
			const docId = subDoc.document?.documentID || subDoc.documentID;

			const existingIndex = this.selectedDocs.findIndex(
				(doc) => doc.id === docId
			);

			if (existingIndex > -1) {
				// Deselect if already selected
				this.selectedDocs.splice(existingIndex, 1);
			} else {
				// Add if not present
				const link =
					subDoc.document?.documentSource?.[0] || subDoc.documentSource?.[0];
				const path = subDoc.document?.path?.[0] || subDoc.path?.[0];

				this.selectedDocs.push({
					id: docId,
					link,
					path,
				});
			}
		},
		closemodal() {
			this.$emit("close-modal");
		},
		selectDocuments() {
			this.$emit("sel-docs", this.selectedDocs);
		},
	},
};
</script>
<style>
.jdp-modal-oveflow-3 {
	height: calc(100vh - 270px);
	max-height: 549px;
	padding: 15px 12px 10px 33px;
	display: flex;
}
.jdp-exist-left-overflow-2 {
	border-right: 1px solid #d9d9d9;
	height: 100%;
	overflow: auto;
}
.sel-exis-selected {
	border: 1px solid #20639b;
	box-shadow: 0px 1px 8px 0px #0000002b;
	border-radius: 8px;
	display: flex;
	align-items: center;
	width: 86%;
}
.sel-exis-unselected {
	border: 1px solid #ffffff;
	box-shadow: 0px 1px 8px 0px #0000002b;
	border-radius: 8px;
	display: flex;
	align-items: center;
	width: 86%;
}
.jdp-exist-right-overflow {
	width: 96%;
	height: 100%;
	overflow: auto;
	box-shadow: 0px 1px 8px 0px #0000002b;
	border-radius: 6px;
	display: flex;
	justify-content: center;
	padding: 15px 0px;
}
.jdp-resume-cont {
	box-shadow: 0px 1px 8px 0px #0000002b;
	border-radius: 4px;
	overflow: hidden;
	width: 458px;
	height: 608px;
}
</style>
